import React, { useEffect, useState } from 'react';
import AdminNav from '../common/adminMenuItems.json';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Link from '@material-ui/core/Link';
import Hidden from '@material-ui/core/Hidden';
import { HEADER_LINKS } from '../common/header-navigation-links';
import { FaChevronRight } from 'react-icons/fa';

const PrimaryNavigation: React.FunctionComponent = (props: any) => {
  const [activeSubMenuId, setActiveSubMenuId] = useState('');

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      const target = event.target as Element;
      if (!target.closest('.centers-nav-list')) {
        setActiveSubMenuId('');
      }
    };

    document.addEventListener('click', handleClickOutside);
    return () => document.removeEventListener('click', handleClickOutside);
  }, []);

  let menuItemsData;
  if (props.user === 'Private') {
    menuItemsData = AdminNav.data;
  } else {
    menuItemsData = HEADER_LINKS;
  }
  const showMenu = (menuId: any, event: any) => {
    setActiveSubMenuId(menuId);

    event.target
      .closest('ul')
      ?.childNodes.forEach((li: any) =>
        li.classList.remove('menu-link-item-active')
      );

    const menuBottom = document.getElementById(menuId);
    if (menuBottom) {
      const menuBottomLi = menuBottom.closest('li');
      menuBottomLi?.classList.add('menu-link-item-active');
    }
  };

  return (
    <List className="centers-nav-list" id="primaryNav1">
      {menuItemsData.map((item: any, i: any) => {
        const gridCols = item.hasPromo
          ? 'grid-cols-3'
          : `grid-cols-${item.columns.length}`;

        const columns = item.columns;
        return (
          <>
            {item.isMobile ? (
              <Hidden lgUp>
                <ListItem className={`${item.cls}`}>
                  <ListItemText>
                    <Link
                      href={`${item.url}`}
                      onMouseOver={(event: any) => {
                        showMenu('nav1' + (i + 1), event);
                      }}
                    >
                      <span className="link-name">{item.name}</span>
                    </Link>
                    {item.children && (
                      <div
                        className="centers-sub-nav mega-menu"
                        id={'nav1' + (i + 1)}
                      >
                        {item.children.map((headerLinks: any, j: any) => {
                          return activeSubMenuId == 'nav1' + (i + 1) ? (
                            <Link href={`${headerLinks.url}`}>
                              <span className="link-name">
                                {headerLinks.name}
                              </span>
                            </Link>
                          ) : null;
                        })}
                      </div>
                    )}
                  </ListItemText>
                </ListItem>
              </Hidden>
            ) : (
              <ListItem className={`${item.cls}`}>
                <ListItemText>
                  <Link
                    className={`center-nav-link`}
                    onClick={(event: any) => {
                      event.preventDefault();
                      const currentMenuId = 'nav1' + (i + 1);
                      setActiveSubMenuId(
                        activeSubMenuId === currentMenuId ? '' : currentMenuId
                      );
                    }}
                  >
                    <span
                      className={`link-name ${
                        activeSubMenuId === 'nav1' + (i + 1)
                          ? 'active-parent-link'
                          : ''
                      }`}
                    >
                      {item.title}
                    </span>
                  </Link>
                  {activeSubMenuId === 'nav1' + (i + 1) && (
                    <div
                      className={`${gridCols} centers-sub-nav mega-menu ${item.className}`}
                      id={'nav1' + (i + 1)}
                    >
                      {item.promo && <PromoSection {...item.promo} />}
                      {columns &&
                        columns.map((column: any[], colIndex: number) => (
                          <ul className="columns" key={colIndex}>
                            {column &&
                              column.map(
                                (headerLink: any, linkIndex: number) => (
                                  <li
                                    key={linkIndex}
                                    className={`py-2 ${
                                      linkIndex === 0 ? 'first-item' : ''
                                    }`}
                                  >
                                    <Link
                                      href={headerLink.url || '#'}
                                      className="flex justify-between w-full link-with-icon items-center py-2"
                                    >
                                      <span className="link-name">
                                        {headerLink.title || 'Untitled'}
                                      </span>
                                      <FaChevronRight className="w-3 h-3 chevron-icon" />
                                    </Link>
                                  </li>
                                )
                              )}
                          </ul>
                        ))}
                    </div>
                  )}
                </ListItemText>
              </ListItem>
            )}
          </>
        );
      })}
    </List>
  );
};

export default PrimaryNavigation;
const PromoSection: React.FC<Record<string, string>> = ({
  title,
  description,
  buttonText,
  buttonUrl,
}) => (
  <div className="header-promo from-blue-50 to-blue-100 p-6 rounded-lg">
    <h5 className="text-base font-semibold  mb-6 text-pc-1 whitespace-pre-wrap">
      {title}
    </h5>
    <p className="text-lg mb-6 text-pc-1 whitespace-pre-wrap">{description}</p>
    <a href={buttonUrl} className="header-promo-btn">
      {buttonText}
    </a>
  </div>
);